import { useEffect, useRef, useState } from 'react';

import { Tooltip, Text } from '@hh.ru/magritte-ui';
import Column from 'bloko/blocks/column';
import { H2 } from 'bloko/blocks/header';
import VSpacing from 'bloko/blocks/vSpacing';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import LocalStorageWrapper from 'bloko/common/storage/LocalStorageWrapper';

import { GbbColumns } from 'src/components/Price/Gbb';
import TariffCard from 'src/components/Price/TariffCard';
import translation from 'src/components/translation';
import { useSelectorNonNullable } from 'src/hooks/useSelector';
import { ZpTariff } from 'src/models/price/zpTariff';

import TariffControls from 'src/pages/PriceZp/components/TariffControls';
import TariffFeatures from 'src/pages/PriceZp/components/TariffFeatures';

const TrlKeys = {
    backofficeTariffsTitle: 'price.backofficeTariffsTitle',
    // temp_exp_34493_start
    zpSprintTooltip: 'price.zpSprintTooltip',
};

const ZP_SPRINT_SEEN_TIMES_KEY = 'ZpSprintSeenTimesKey';
const ZP_SPRINT_SEEN_TIMES_MAX = 3;
// temp_exp_34493_end

const TabContent: TranslatedComponent = ({ trls }) => {
    const tariffNames = useSelectorNonNullable(({ priceZp }) => priceZp.tariffNames || []);
    const tariffs = useSelectorNonNullable(({ priceZp }) => priceZp.tariffs);
    const backofficeTariffNames = useSelectorNonNullable(({ priceZp }) => priceZp.backofficeTariffNames || []);
    const backofficeTariffs = useSelectorNonNullable(({ priceZp }) => priceZp.backofficeTariffs);

    // temp_exp_34493_start
    const zpSprint = useRef(null);
    const [visible, setVisible] = useState(false);

    const onClose = () => {
        setVisible(false);
    };

    useEffect(() => {
        const _seen = LocalStorageWrapper.getItem(ZP_SPRINT_SEEN_TIMES_KEY);
        const seen = Number(_seen || 0);
        if (Number(seen) < ZP_SPRINT_SEEN_TIMES_MAX) {
            setVisible(true);
            LocalStorageWrapper.setItem(ZP_SPRINT_SEEN_TIMES_KEY, String(seen + 1));
        }
    }, []);
    // temp_exp_34493_end

    return (
        <>
            <GbbColumns>
                {tariffNames.map((tariffName) => {
                    // temp_exp_34493_start
                    if (tariffName === ZpTariff.ZpSprint) {
                        return (
                            <>
                                <div ref={zpSprint} key={`${tariffName}_wrapper`}>
                                    <TariffCard
                                        key={tariffName}
                                        tariff={tariffs[tariffName]}
                                        features={<TariffFeatures tariff={tariffs[tariffName]} />}
                                        controls={<TariffControls tariff={tariffs[tariffName]} />}
                                    />
                                </div>
                                <Tooltip
                                    key={`${tariffName}_tooltip`}
                                    activatorRef={zpSprint}
                                    placement="top-center"
                                    closeByClickOutside
                                    visible={visible}
                                    onClose={onClose}
                                    showClose
                                >
                                    <Text>{trls[TrlKeys.zpSprintTooltip]}</Text>
                                </Tooltip>
                            </>
                        );
                    }
                    // temp_exp_34493_end
                    return (
                        <TariffCard
                            key={tariffName}
                            tariff={tariffs[tariffName]}
                            features={<TariffFeatures tariff={tariffs[tariffName]} />}
                            controls={<TariffControls tariff={tariffs[tariffName]} />}
                        />
                    );
                })}
            </GbbColumns>
            {!!backofficeTariffNames.length && (
                <>
                    <Column xs="4" s="8" m="12" l="12">
                        {!!tariffNames.length && <VSpacing base={14} />}
                        <H2>{trls[TrlKeys.backofficeTariffsTitle]}</H2>
                        <VSpacing base={8} />
                    </Column>
                    <GbbColumns>
                        {backofficeTariffNames.map((tariffName) => (
                            <TariffCard
                                key={tariffName}
                                tariff={backofficeTariffs[tariffName]}
                                features={<TariffFeatures tariff={backofficeTariffs[tariffName]} />}
                                controls={<TariffControls tariff={backofficeTariffs[tariffName]} />}
                            />
                        ))}
                    </GbbColumns>
                </>
            )}
        </>
    );
};

export default translation(TabContent);
